<template>
	<div>
		<v-dialog v-if="isVisible && fullscreen" v-model="isVisible" :persistent="modal" fullscreen hide-overlay scrollable transition="dialog-bottom-transition">
			<slot></slot>
		</v-dialog>

		<v-dialog v-if="isVisible && fullscreen === false" v-model="isVisible" :persistent="modal" :width="width" scrollable>
			<slot></slot>
		</v-dialog>
	</div>
</template>

<script>
export default {
	name: "PopupModal",

	data: () => ({
		isVisible: false,
		fullscreen: true,
		modal: true,
		width: 500,
	}),

	methods: {
		open(fullscreen = true, modal = true, width = 500) {
			this.fullscreen = fullscreen
			this.modal = modal
			this.isVisible = true
			this.width = width
		},

		close() {
			this.isVisible = false
		},
	},
}
</script>
